import { TranslationKeys } from "@shared/common/i18n/types";
import { LanguageNameSpaces } from "@shared/types";
import { TradingIntent } from "features/onboarding/guided/intent";
import { VisualMethod } from "features/onboarding/visuals/types";

type Key = TranslationKeys<LanguageNameSpaces.ONBOARDING>;

/** The walkthrough's steps, one per event of the example (short, one line). */
export const WALKTHROUGH_STEPS: Record<TradingIntent, Key[]> = {
  signals: [
    "walkthrough.steps.signals.1",
    "walkthrough.steps.signals.2",
    "walkthrough.steps.signals.3",
    "walkthrough.steps.signals.4",
  ],
  grid: [
    "walkthrough.steps.grid.1",
    "walkthrough.steps.grid.2",
    "walkthrough.steps.grid.3",
  ],
  tradingview: [
    "walkthrough.steps.tradingview.1",
    "walkthrough.steps.tradingview.2",
    "walkthrough.steps.tradingview.3",
  ],
  dca: [
    "walkthrough.steps.dca.1",
    "walkthrough.steps.dca.2",
    "walkthrough.steps.dca.3",
    "walkthrough.steps.dca.4",
  ],
  hedging: [
    "walkthrough.steps.hedging.1",
    "walkthrough.steps.hedging.2",
    "walkthrough.steps.hedging.3",
  ],
};

/**
 * The steps of the bot illustrations (new look), one per event of the
 * illustration's timeline (`VISUAL_EVENTS`): a short title, and a line that
 * opens while the step is active.
 */
export interface SceneStep {
  title: Key;
  description: Key;
}
const steps = (method: VisualMethod, count: number): SceneStep[] =>
  Array.from({ length: count }, (_, index) => ({
    title: `walkthrough.scene.${method}.${index + 1}.title` as Key,
    description: `walkthrough.scene.${method}.${index + 1}.description` as Key,
  }));
export const SCENE_STEPS: Record<VisualMethod, SceneStep[]> = {
  signals: steps("signals", 4),
  grid: steps("grid", 4),
  dca: steps("dca", 4),
  tradingview: steps("tradingview", 3),
};
